import { FC } from 'react';

import AddHoldingClassModalHeader from './components/AddHoldingClassModalHeader';
import AddHoldingClassModalBody from './components/AddHoldingClassModalBody';
import AddHoldingClassModalFooter from './components/AddHoldingClassModalFooter';

import '../Modals.scss';
import CustomLoading from '../../CustomLoading';
import { useAddHoldingClassModal } from './context/AddHoldingClassModalContext';

const AddHoldingClassModal: FC = () => {
  const { data } = useAddHoldingClassModal();

  return (
    <>
      <AddHoldingClassModalHeader />
      <AddHoldingClassModalBody />
      <AddHoldingClassModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddHoldingClassModal;
